import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Pagination,
  TableCell,
  TableFooter,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import { getPetsAppointmentsReportData } from "../../../../redux/reducers/reportSlice";
import { AppColors } from "../../../../util/AppColors";
import ReportTable from "../ReportTable";
import { nameExpan } from "../tableHeaders";

const tableHdrs = [
  "petName",
  "appointmentId",
  "caseId",
  "vetName",
  "visitType",
  "status",
  "appointmentDetails",
  "date",
  "system",
  "condition",
];

const AppointmentsReport = () => {
  const dispatch = useDispatch();
  const [crntTblHeders, setCrntTblHeders] = useState(tableHdrs?.slice(0, 5));
  const [activeTableHeaders, setActiveTableHeaders] = useState(
    tableHdrs?.slice(0, 5)?.map((pd, i) => ({ name: pd, isSelected: true, i })),
  );
  const [editColModVsble, setEditColModVsble] = useState(false);
  const [page, setPage] = useState(1);
  const { appointments } = useSelector((state) => state?.report);
  const rowsPerPage = 10;

  useEffect(() => {
    dispatch(getPetsAppointmentsReportData(`?type=appointments`));
  }, [dispatch]);

  const handleEditColumn = () => {
    const reqList = tableHdrs?.map((pd, i) => {
      const isObjMat = activeTableHeaders?.find(
        (tblHdr) => tblHdr?.name === pd,
      );
      return { name: pd, isSelected: isObjMat?.isSelected ?? false, i };
    });
    setActiveTableHeaders(reqList);
    setEditColModVsble(true);
  };

  const onEditModClose = () => {
    setEditColModVsble(false);
  };

  const handleSelcetdColumn = (selected, ind) => {
    const reqList = activeTableHeaders?.map((act, i) => {
      if (i === ind) return { ...act, isSelected: selected };
      return act;
    });
    setActiveTableHeaders(reqList);
  };

  const handleSaveTableColumn = () => {
    const reqList = activeTableHeaders
      ?.filter((act) => act?.isSelected)
      ?.map((act) => {
        return act?.name;
      });
    setCrntTblHeders(reqList);
    setEditColModVsble(false);
  };

  const totalPage = Math.ceil((appointments?.totalRecords ?? 0) / rowsPerPage);

  const handleChangePage = (e, selectedPage) => {
    setPage(selectedPage);
  };

  const getTableData = () => {
    return (appointments?.data ?? [])?.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage,
    );
  };

  const handleOpenChart = () => {
    console.log("Log triggered");
  };

  return (
    <>
      <div className="flex-row-ali-cen mt5 mh20">
        <Typography className="gray15 fs16 font-bold">
          Total {appointments?.totalRecords ?? 0}
        </Typography>
        <div
          className="flex-row-ali-cen ml50 cursor"
          onClick={handleEditColumn}
        >
          <EditOutlinedIcon
            sx={{
              color: AppColors.appPrimary,
              width: 20,
              height: 20,
            }}
          />
          <Typography className="blue-color fs16 font-medium ml5">
            Edit columns ({crntTblHeders?.length})
          </Typography>
        </div>
        <div className="flex-row-ali-cen ml50 cursor" onClick={handleOpenChart}>
          <AutoGraphIcon
            sx={{
              color: AppColors.appPrimary,
              width: 20,
              height: 20,
            }}
          />
        </div>
        {/* <Typography
          className="red-color fs16 font-medium cursor ml20"
          onClick={handleResetFilter}
        >
          Reset
        </Typography> */}
      </div>
      <div>
        <ReportTable datas={getTableData()} columns={crntTblHeders} />
        <div className="flex1-end">
          {Math.ceil((appointments?.totalRecords ?? 0) / rowsPerPage) > 1 ? (
            <TableFooter>
              <TableRow>
                <TableCell colSpan={12}>
                  <div className="flex1-end">
                    <Pagination
                      count={totalPage}
                      variant="outlined"
                      color="primary"
                      page={page}
                      onChange={handleChangePage}
                    />
                  </div>
                </TableCell>
              </TableRow>
            </TableFooter>
          ) : null}
        </div>
      </div>

      <CustomModal
        open={editColModVsble}
        onClose={onEditModClose}
        header="Columns"
        modal
        modalWidth={25}
      >
        <div className="ph20 scroll-70vh">
          {activeTableHeaders?.map((hr) => (
            <div className="flex-row" key={hr?.i}>
              <CustomCheckbox
                label={nameExpan?.[hr?.name]}
                checked={hr?.isSelected}
                onChange={() => handleSelcetdColumn(!hr?.isSelected, hr?.i)}
              />
            </div>
          ))}
          <div className="flex-end mb10">
            <div>
              <CustomButton
                text="Save"
                smallBtn
                onClick={handleSaveTableColumn}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default AppointmentsReport;
